import "material-design-icons-iconfont/dist/material-design-icons.css";
import "@fortawesome/fontawesome-free/css/all.css";
import Vue from "vue";
import Vuetify from "vuetify/lib";

const conf = {
  icons: {
    iconfont: ["md" || "fa"]
  },
  theme: {
    dark: false,
    themes: {
      light: {
        primary: "#4e558a",
        secondary: "#d7e3fd",
        label: "#5a71c4",
        special: "#688eee",
        success: "#92d050",
        error: "#9b0d0d",
        warning: "#d38d24"
      }
    }
  }
};

Vue.use(Vuetify);

export default new Vuetify(conf);
